import { inject } from '@angular/core';
import { ConfigService } from '../services/config/config.service';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot } from '@angular/router';

export const canActivate: CanActivateFn = () => {
    const configService = inject(ConfigService);      
    return configService.config !== undefined;
};

export const ConfigReadyGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => canActivate(route, state);